<template>

    <Tabs value="0">

        <TabList>
            <Tab value="0">
                <i class="fa fa-info-circle me-2"></i>
                <span>{{TR.info}}</span>
            </Tab>
            <Tab value="1">
                <i class="fas fa-image me-2"></i>
                <span>{{TR.images}}</span>
            </Tab>
        </TabList>
        <TabPanels>
            <TabPanel value="0">
                <DynamicTable2 v-bind:mainref="mainref" :data="data" />
            </TabPanel>

            <TabPanel value="1">
                <div class="product_images mt-3">
                    <div class="row mb-5">
                        <!-- <div class="col">
                            <FileUpload
                                v-model="PO['images[]']"
                                name="images[]"
                                accept="image/*"
                                mode="basic"
                                :multiple="true"
                                :chooseLabel="TR.image_file"
                                :maxFileSize="G.uploadedFileSize"
                                @select="onFileChanged($event)"
                                uploadIcon="fas fa-image"
                            >
                            </FileUpload>
                        </div> -->
                        <div class="col">
                            <button class="btn btn-secondary me-3" @click="addImage()"><i class="fas fa-image me-1"></i> {{TR.image_file}}</button>
                        <!-- </div>
                        <div class="col"> -->
                            <button class="btn btn-info" @click="addImage('link')"><i class="fas fa-link me-1"></i> {{TR.image_link}}</button>
                        </div>
                    </div>
                </div>

                <draggable
                        tag="ul"
                        :list="PO['newdata']['new_product_images']"
                        class="list-group"
                        item-key="id"
                        handle=".handle"
                        ghost-class="draggable-ghost"
                        @end="onEnd"
                    >
                        <template #header>
                            <div class="row bg-light text-center1 m-0 p-2 border text-center">
                                <div class="col-1">{{ TR.move }}</div>
                                <div class="col-1">{{ TR.id }}</div>
                                <div class="col-1">{{ TR.remove }}</div>
                                <div class="col-1">{{ TR.image }}</div>
                                <div class="col-6">{{ TR.file }} {{ TR.or }} {{ TR.link }}</div>
                                <div class="col-2">{{ TR.rank }}</div>
                            </div>
                        </template>

                        <template #item="{element}">
                            <div class="draggable-item list-group-item">

                                <div class="row d-flex align-items-center m-0">
                                    <div class="col-12 col-sm-1">
                                        <i class="fas fa-arrows-alt p-2 pe-4 handle cursor-pointer"></i>
                                    </div>
                                    <div class="col-12 col-sm-1">
                                        {{ element.id }}
                                    </div>
                                    <div class="col-12 col-sm-1">
                                        <button
                                            class="btn btn-danger"
                                            @click="removeImageItem(element)"
                                        >
                                            <i class="fas fa-trash"></i>
                                        </button>
                                    </div>
                                    <div class="col-12 col-sm-1">
                                        <Image
                                            v-if="element.type == 'file'"
                                            :src="element.preview_image"
                                            :alt="TR.image"
                                            width="40"
                                            :preview="true"
                                        />
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <InputFile v-if="element.type !== undefined && element.type == 'file'" v-model="element.image" :placeholder="TR.select_file" class="me-2" :sizeErrorLabel="TR.file_size_limit_error" :multiple="false" :maxSize="G.uploadedFileSize" accept="image/*" @change="onFileChanged($event.target, element.id)" />
                                        <!-- <FileUpload
                                            v-if="element.type !== undefined && element.type == 'file'"
                                            v-model="element.image"
                                            mode="basic"
                                            name="images[]"
                                            :customUpload="false"
                                            @select="onFileChanged($event, element.id)"
                                            accept="image/*"
                                            :invalidFileSizeMessage="TR.invalidFileSizeMessage"
                                            :invalidFileLimitMessage="TR.invalidFileLimitMessage"
                                        >
                                            <template #empty>
                                                <p>{{TR.drag_file}}</p>
                                            </template>
                                        </FileUpload> -->
                                        <input v-else-if="element.type !== undefined && element.type == 'link'" type="text" :placeholder="TR.image_link" v-model="element.image" class="form-control" />
                                    </div>
                                    <div class="col-12 col-sm-2">
                                        <InputNumber
                                            v-model="element.rank"
                                            :placeholder="TR.rank"
                                            :useGrouping="false"
                                            :inputStyle="{width: '6rem'}"
                                            @click.stop.prevent
                                            :min="1"
                                            :max="1000"
                                            integeronly
                                            />
                                    </div>
                                    <!-- <div class="col-12 col-sm-2">
                                        <button class="btn btn-danger ms-2" @click="removeImageLink(element.id)"><i class="fas fa-trash"></i></button>
                                    </div> -->
                                </div>

                            </div>
                        </template>
                </draggable>

            </TabPanel>

        </TabPanels>
    </Tabs>

</template>


<script>
    import { ref, onMounted, watchEffect } from "vue";

    import { useStore } from "@/store";

    import { G } from "@/_common";

    import Tabs from 'primevue/tabs';
    import TabList from 'primevue/tablist';
    import Tab from 'primevue/tab';
    import TabPanels from 'primevue/tabpanels';
    import TabPanel from 'primevue/tabpanel';
    import Image from "primevue/image";
    import InputNumber from "primevue/inputnumber";
    // import FileUpload from "primevue/fileupload";

    import draggable from 'vuedraggable';

    import { useModelWrapper } from "@/utils/modelWrapper";

    import InputFile from "@/components/field/InputFile";
    import DynamicTable2 from "@/components/table/DynamicTable2";

    export default {
        name: 'ProductsInfo',
        props: {
            data: {
                type: Object,
                default: ()=> {}
            },
            mainref: {
                type: Object,
                default: ()=> {}
            },
        },
        components: {
            Tabs,
            TabList,
            Tab,
            TabPanels,
            TabPanel,
            Image,
            InputNumber,
            // FileUpload,
            DynamicTable2,
            InputFile,
            draggable,
        },
        setup(props, { emit }) {
            const store = useStore();

            const TR = ref({});
            const PO = useModelWrapper(props, emit, "mainref");

            watchEffect(() => {
                TR.value = store.getTranslation();
            });

            const onFileChanged = (e, idn) => {
                if (e.files){
                    let im = PO.value['newdata']["new_product_images"].filter(f => f.id == idn);
                    if( im.length ){
                        im[0].image = e.files[0].name;
                        // im[0].preview_image = e.target.value;
                        // const reader = new FileReader();
                        // reader.onload = (e) => {
                        //     im[0].preview_image = e.target.result;
                        // };
                        // reader.readAsDataURL(e.files[0]);

                        im[0].preview_image = URL.createObjectURL(e.files[0]);
                    }
                    PO.value['newdata']["images"].push(e.files[0]);
                }
            };

            const addImage = (type) => {
                if( type === undefined || type === '' ){
                    type = 'file';
                }
                let new_rank = PO.value['newdata']["new_product_images"].length+1;
                let idn = new_rank*-1;
                let image_item = {
                    "id": idn,
                    "preview_image": '',
                    "image": '',
                    "type": type,
                    "rank": new_rank,
                };
                PO.value['newdata']["new_product_images"].push(image_item);
            };
            // const addUrl = () => {
            //     let new_rank = PO.value['newdata']["new_product_images"].length+1;
            //     let idn = new_rank*-1
            //     let image_item = {
            //         "id": idn,
            //         "url": '',
            //         "rank": new_rank,
            //     };
            //     PO.value['newdata']["new_product_images"].push(image_item);
            // };
            const onEnd = () => {
                PO.value['newdata']["new_product_images"].forEach((e, i)=>{
                    e.rank = i + 1;
                });
            };

            const removeImageItem = (item) => {
                if( PO.value['newdata']["new_product_images"].length ){
                    PO.value['newdata']["new_product_images"].forEach((a, i) => {
                        if( a.id == item.id ){
                            PO.value['newdata']["new_product_images"].splice(i, 1);
                        }
                    });
                }
            };

            // const removeProductImage = (product_id, image_id) => {
            //     G.alert.error({ type: 'error', title: TR.value.warning, msg: TR.value.msg_remove_question, yesTitle: TR.value.yes, yes: async () => {
            //         await ajax({
            //             url: store.getProductsImageRemoveLink(product_id),
            //             method: 'delete',
            //             content_type: 'application/json; charset=UTF-8',
            //             data: [image_id],
            //             success: (e) => {
            //                 const res = e.data || null;
            //                 G.alert.success(res.detail.title);
            //             },
            //         });
            //     }, noTitle: TR.value.no, no: () => {} })
            // };

            onMounted(async () => {
                if( PO.value['newdata'] === undefined ){
                    PO.value['newdata'] = {};
                }
                if( props.data.data.product_images !== undefined ){
                    props.data.data.product_images.forEach(im => {
                        if( im.type == 'file' ){
                            im.preview_image = im.image;
                        }
                    });
                }
                PO.value['newdata']["new_product_images"] = props.data.data.product_images !== undefined ? [...props.data.data.product_images] : [];
                PO.value['newdata']["images"] = [];
            });

            return {
                G,
                TR,
                PO,
                addImage,
                onFileChanged,
                onEnd,
                removeImageItem,
            };
        },
    };
</script>


<style lang="scss">
    .product_images{
        .p-dropdown{
            width: 12rem;
        }
        .p-inputnumber-input{
            width: 100% !important;
        }
    }
</style>

